import commonSettingSlice from './commonSetting.slice';
import homePageSlice from './homePage.slice';
import orderPageSlice from './orderPage.slice';
import settingsPageSlice from './settings.slice';
import disputePageSlice from './dispute.slice';

export default { commonSettingSlice, homePageSlice, orderPageSlice, settingsPageSlice, disputePageSlice };
